import { Box, styled } from '@mui/material';

export const BottomContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;
